import {parseJSON} from '../_helpers/fetch';
import {User} from './User';
import {Choice} from '../types';

export type EtlResponse = any;

export class Etl {
    private static instance: Etl;
    private baseUrl: string = '/p/flow/api/etl';

    private requestHeaders: any = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };

    private constructor() {
    }

    public static getInstance(): Etl {
        if (!Etl.instance) {
            Etl.instance = new Etl();
        }

        return Etl.instance;
    }

    public employeeAutocompleter(searchValue: string): Promise<Choice[]> | void {
        const minimumInputLength: number = 3;
        const resultProperty = 'result';
        const resultValueProperty = 'mail';
        const resultTextProperty = 'mail';

        if (searchValue.length < minimumInputLength) return;

        return Etl.getInstance().process('employee-autocompleter', {q: searchValue})
            .then((response) => {
                return response.json[resultProperty].map((item: any) => ({
                    value: item[resultValueProperty],
                    label: item[resultTextProperty],
                    text: item[resultTextProperty],
                    ...item
                }));
            });
    }

    public process(pipeline: string, data: object): Promise<EtlResponse> {
        return this.fetch('/process/' + pipeline, data);
    }

    private fetch(endpoint: string, body: object): Promise<EtlResponse> {
        console.log('fetching ' + this.baseUrl + endpoint);
        return fetch(this.baseUrl + endpoint + '/json', {
            headers: {
                ...this.requestHeaders,
                'Authorization': 'Bearer ' + User.getInstance().getAuthToken()
            },
            method: 'POST',
            body: JSON.stringify(body)
        })
            .then(parseJSON);
    }
}